<template>
    <v-app id="app">
        <development v-if="development" />
        <router-view v-if="loaded"/>
    </v-app>
</template>

<script>

import development from '@dev'

export default {
    components: {
        development
    },
    data () {
        const rv = {
            development: process.env.NODE_ENV === 'development',
            loaded: false
        }

        if (typeof (loyaltyAuthorConfig) !== 'undefined') {
            // eslint-disable-next-line no-undef
            if (loyaltyAuthorConfig.targetPage) {
                // eslint-disable-next-line no-undef
                rv.targetPage = '/' + loyaltyAuthorConfig.targetPage
            } else {
                // eslint-disable-next-line no-undef
                rv.targetPage = loyaltyAuthorConfig.useLandingView === 'nsTrue' ? '/landing' : false
            }
        }

        return rv
    },
    async beforeCreate () {
        try {
            // load feature flags
            await this.$features.$waitForLoad()
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log('Encountered an error loading feature flags. The application will proceed with all optional features disabled')
            // eslint-disable-next-line no-console
            console.error('Feature loading error:', e)
        }
        this.loaded = true
    },
    beforeMount () {
        if (this.targetPage) {
            this.$router.push(this.targetPage)
        }
    }
}

</script>

<style lang="scss">

@import './scss/styles.scss';

#mainContainer {
    max-width: 100%;

    & > #content {
        overflow: hidden;
        max-width: 100%;
        padding-top: 0;
        padding-bottom: 0;
    }

    & .parsys.bodyContent {
        margin-bottom: 0;
    }
}

#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #272525;
}

</style>

<style scoped>

.v-application {
    ::v-deep {
        .v-application--wrap > .container {
            margin: 0;
            padding-left: 0;
            padding-right: 0;
        }
    }
}

</style>
